export var NetworkAddressRegex;
(function (NetworkAddressRegex) {
    NetworkAddressRegex["BTC"] = "^[a-zA-HJ-NP-Z0-9]{25,62}$";
    // BTC = '^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$',
    NetworkAddressRegex["ETH"] = "^0x[0-9a-fA-F]{40}$";
    // ADA = '^addr[0-9a-zA-Z]{59}$', // TODO: tmp, till better version comes
    NetworkAddressRegex["SOL"] = "^[1-9A-HJ-NP-Za-km-z]{32,44}$";
    NetworkAddressRegex["TRX"] = "^[Tt][A-HJ-NP-Za-km-z1-9]{33}$";
    // DOT = '^[1-9A-HJ-NP-Za-km-z]{48}$',
    NetworkAddressRegex["BSC"] = "^0x[0-9a-fA-F]{40}$";
    NetworkAddressRegex["DOGE"] = "^(D|9)[1-9A-HJ-NP-Za-km-z]{33}$";
    // LTC = '^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$', // TODO: tmp, till better version comes
    NetworkAddressRegex["MATIC"] = "^0x[0-9a-fA-F]{40}$";
})(NetworkAddressRegex || (NetworkAddressRegex = {}));
//# sourceMappingURL=network-address-regex.enum.js.map